import React, { useEffect, useState } from "react";
import FileDownload from "js-file-download";
import axios from "axios";

// const env = import.meta.env;
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//Fetch Incident Response Playbook List
export const fetchIncidentResponsePlaybook = async (
  companyProfileId: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/Playbook/CompanyId/${companyProfileId}/Details`
    );

    // console.log("fetchIncidentResponsePlaybook res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Incident Response Playbook Details
export const fetchIncidentResponsePlaybookDetails = async (
  playbookId: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/Playbook/id/${playbookId}/Details`
    );

    // console.log("fetchIncidentResponsePlaybook res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Create Incident Response Playbook
export const createIncidentResponsePlaybook = async (payload: any) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/api/Plan/Playbook`, payload);

    // console.log("createIncidentResponsePlaybook res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Update Incident Response Playbook
export const updateIncidentResponsePlaybook = async (payload: any) => {
  try {
    const res = await axios.put(`${API_BASE_URL}/api/Plan/Playbook`, payload);

    // console.log("updateIncidentResponsePlaybook res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Delete Incident Response Playbook
export const deleteIncidentResponsePlaybook = async (
  userId: number,
  playbookId: number
) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/Playbook/${playbookId}/${userId}/Delete`
    );

    // console.log("deleteIncidentResponsePlaybook res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Download Incident Response Playbook
export const downloadIncidentResponsePlaybook = async (payload: any, compnayProfileID: number) => {
  try {
    axios({
      url: `${API_BASE_URL}/api/Plan/Playbook/Download/Document?companyProfileid=${compnayProfileID}&playbookid=${payload.playbookID}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      // console.log("downloadIncidentResponsePlaybook res", payload, response);
      FileDownload(response.data, `${payload.playbookName}.docx`);
    });
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Incident Response Playbook Template
export const fetchIncidentResponsePlaybookTemplate = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/Playbook/Import/Details`
    );

    // console.log("fetchIncidentResponsePlaybookTemplate res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};
